// extracted by mini-css-extract-plugin
export default {"posterResultsContainer":"PosterResults_posterResultsContainer__l5mHe","posterResultbgContainer":"PosterResults_posterResultbgContainer__htqw6"};